<template>
  <v-combobox
    v-model="searchField"
    :items="searchList"
    color="white"
    item-text="name"
    v-if="searchList"
    background-color="white"
    dense
    class="autocomplete"
    @update:search-input="updateModel"
  >
    <template v-slot:append-outer>
      <v-icon @click="search" color="white" class="icon">mdi-magnify</v-icon>
    </template>
  </v-combobox>
</template>

<script>
import Axios from '@/core/Axios';

export default {
  name: 'Search',
  data() {
    return {
      valueToSearch: null,
      searchField: '',
      searchList: null,
      axios: new Axios(),
      searchResult: null,
    };
  },
  mounted() {
    this.getProductListToSearch();
  },
  methods: {
    getProductListToSearch() {
      this.axios.makeCall('GET', 'norbit/product/getsearchlist')
        .then((response) => {
          this.searchList = response;
        })
        .catch((error) => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
              this.text.messages[error],
          });
        });
    },
    updateModel(value) {
      this.valueToSearch = value;
    },
    search() {
      this.axios.makeCall('POST', 'norbit/product/searchproduct', {
        search: this.valueToSearch,
      })
        .then((response) => {
          this.searchResult = response;
          this.$store.commit('updateProductsList', this.searchResult);
          if (this.searchResult) {
            this.$router.push('/search');
          }
        })
        .catch((error) => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
              this.text.messages[error],
          });
        });
    },
  },
};
</script>

<style scoped>
.icon {
  margin-top: -3px;
}

.autocomplete > div {
  border: transparent !important;
}

input {
  border: transparent;
}
</style>
